export default __webpack_public_path__ + "static/media/icon-x.03432b34.svg";